import { createSlice } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { normalize } from 'normalizr';
import { itemsFetchStatus, saveNormalizedData } from 'data/core/utils';
import { FetchStatus } from '../core';
import { spaceTabSchema } from '../spaces/schema';
const initialState = {
    items: {},
    itemsFetchStatus: {},
    loading: false,
    error: null,
    creating: false,
    createError: null,
    embedding: false,
    activeTabKey: '',
    updating: false,
    deleting: false,
    deleteError: null,
    isLoading: false,
    isError: false
};
export const spaceTabsSlice = createSlice({
    initialState,
    name: 'spaceTabs',
    reducers: (create)=>({
            setActiveTabKey: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    activeTabKey: payload
                };
            }),
            addSpaceTab: create.reducer((state, { payload })=>{
                const data = normalize(payload, spaceTabSchema);
                return merge({}, {
                    ...state,
                    items: {
                        ...state.items,
                        ...data.entities.spaceTabs
                    },
                    embedding: false,
                    activeTabKey: String(payload.spaceTabId)
                });
            }),
            updateSpaceTabTitle: create.reducer((state, { payload })=>{
                var _state_items_payload_spaceId;
                // As this is how immer works;
                state.items[payload.spaceId].spaceTabTitle = payload.spaceTabTitle || ((_state_items_payload_spaceId = state.items[payload.spaceId]) === null || _state_items_payload_spaceId === void 0 ? void 0 : _state_items_payload_spaceId.spaceTabTitle) || '';
            }),
            createStart: create.reducer((state)=>({
                    ...state,
                    creating: true
                })),
            embedStart: create.reducer((state)=>({
                    ...state,
                    embedding: true
                })),
            createSuccess: create.reducer((state, { payload })=>{
                const normalized = normalize(payload, spaceTabSchema);
                const tempState = {
                    ...state
                };
                tempState.items = omit(state.items, 0);
                return merge({}, tempState, {
                    items: {
                        ...normalized.entities.spaceTabs
                    },
                    activeTabKey: String(payload.spaceTabId),
                    embedding: false,
                    creating: false,
                    error: null,
                    isError: false
                });
            }),
            createFailure: create.reducer((state)=>{
                return {
                    ...state,
                    embedding: false,
                    creating: false,
                    error: null,
                    isError: true
                };
            }),
            saveSpaceTabs: create.reducer((state, { payload })=>{
                const { data, fetchStatus } = payload;
                const { entities: { spaceTabs }, result } = normalize(data, [
                    spaceTabSchema
                ]);
                return merge({}, state, {
                    items: spaceTabs,
                    itemsFetchStatus: itemsFetchStatus(result, fetchStatus, state.itemsFetchStatus),
                    updating: false,
                    creating: false
                });
            }),
            saveNormalizedSpaceTabs: create.reducer(saveNormalizedData),
            deleteStart: create.reducer((state)=>{
                return {
                    ...state,
                    deleting: true
                };
            }),
            deleteSuccess: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    items: omit(state.items, payload),
                    deleting: false
                };
            }),
            deleteFailure: create.reducer((state)=>{
                return {
                    ...state,
                    deleting: false
                };
            }),
            updateStart: create.reducer((state)=>{
                return {
                    ...state,
                    updating: true
                };
            }),
            updateSuccess: create.reducer((state)=>{
                return {
                    ...state,
                    updating: false
                };
            }),
            fetchDetailStart: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    itemsFetchStatus: {
                        ...state.itemsFetchStatus,
                        [payload]: FetchStatus.Loading
                    }
                };
            }),
            addTaskToSpaceTab: create.reducer((state, { payload })=>{
                const { spaceTabId, taskId } = payload;
                let spaceTab = state.items[spaceTabId];
                if (spaceTab) {
                    spaceTab = {
                        ...spaceTab,
                        taskList: [
                            ...spaceTab.taskList,
                            taskId
                        ]
                    };
                    return dotPropImmutable.set(state, `items.${spaceTabId}`, spaceTab);
                }
                return state;
            }),
            updateSpaceTabTaskList: create.reducer((state, { payload })=>{
                const { spaceTabId, taskId, tempTaskId } = payload;
                let spaceTab = state.items[spaceTabId];
                if (spaceTab) {
                    spaceTab = {
                        ...spaceTab,
                        taskList: [
                            ...spaceTab.taskList.filter((t)=>t !== tempTaskId),
                            taskId
                        ]
                    };
                    return dotPropImmutable.set(state, `items.${spaceTabId}`, spaceTab);
                }
                return state;
            }),
            removeTaskFromSpaceTab: create.reducer((state, { payload })=>{
                const { spaceTabId, taskId } = payload;
                let spaceTab = state.items[spaceTabId];
                if (spaceTab) {
                    spaceTab = {
                        ...spaceTab,
                        taskList: spaceTab.taskList.filter((t)=>t !== taskId)
                    };
                    return dotPropImmutable.set(state, `items.${spaceTabId}`, spaceTab);
                }
                return state;
            })
        })
});
